import {
    EVENT_THEME_PRESET_META,
    eventThemePresetLabel,
    eventThemePresetSwatch
} from '@odo/shared-ui';
import { PresentationSelect, type PresentationSelectOption } from './PresentationSelect';

const THEME_KEYS = Object.keys(EVENT_THEME_PRESET_META);

function ThemeSwatch({ presetKey }: { presetKey: string }) {
    return (
        <span
            aria-hidden="true"
            className="h-5 w-5 flex-shrink-0 rounded-full ring-1 ring-black/10"
            style={{ backgroundColor: eventThemePresetSwatch(presetKey) }}
        />
    );
}

const THEME_OPTIONS: PresentationSelectOption[] = THEME_KEYS.map((key) => ({
    value: key,
    label: eventThemePresetLabel(key),
    render: () => <ThemeSwatch presetKey={key} />
}));

interface EventThemePickerProps {
    id: string;
    value: string;
    onChange: (key: string) => void;
    disabled?: boolean;
}

// A custom listbox so each of the 20 theme presets can show its actual swatch
// color next to the label - a native `<select>` can't render that inline.
export function EventThemePicker({ id, value, onChange, disabled }: EventThemePickerProps) {
    return (
        <PresentationSelect
            id={id}
            value={value}
            options={THEME_OPTIONS}
            onChange={onChange}
            disabled={disabled}
        />
    );
}
